import styled, { css } from 'styled-components';

export const Element = styled.div`
  ${({ theme }) => {
    return css`
      background-color: rgba(0 0 0 / 1);
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;

      transition: all 0.15s ease;
      z-index: 3000;

      .swiper {
        width: 100%;
        height: 100%;

        .swiper-wrapper {
          .swiper-slide {
            background: rgba(0, 0, 0, 0.2);
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
          }
        }
      }

      // Close Button
      button:nth-of-type(3) {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        outline: 0;
        z-index: 1000;
      }
    `;
  }};
`;

export const Figure = styled.figure<{ show: boolean }>`
  ${({ theme, show }) => {
    return css`
      width: 80%;
      height: 50%;
      opacity: 0;
      transition: all 0.3s ease;
      ${show &&
      css`
        opacity: 1;
      `};
      @media screen and (min-width: ${theme.breakpoint.sm}) {
        height: 80%;
      }
    `;
  }};
`;

export const FigCaption = styled.figcaption`
  ${({ theme }) => {
    return css`
      text-align: center;
      padding: 1rem 0;
      color: ${theme.color.white};
    `;
  }};
`;

export const VideoWrapper = styled.div`
  ${({ theme }) => {
    return css`
      position: relative;
      aspect-ratio: 11/6;
      margin: 0 auto;
      overflow: hidden;
      border-radius: ${theme.radius.sm};

      iframe {
        width: 100%;
        height: 100%;
      }
    `;
  }};
`;
